import React from 'react'
import { storiesOf } from '@storybook/react'

import AutoSubIcon from 'components/AutoSubIcon'

storiesOf('AutoSubIcon', module)
  .add('default', () => (
    <>
      <AutoSubIcon />
      <AutoSubIcon color="error" />
      <AutoSubIcon color="primary" />
      <AutoSubIcon color="secondary" />
      <br/>
      <AutoSubIcon style={{ height: 36, width: 60 }} />
      <AutoSubIcon style={{ height: 36, width: 60 }} color="error" />
      <AutoSubIcon style={{ height: 36, width: 60 }} color="primary" />
      <AutoSubIcon style={{ height: 36, width: 60 }} color="secondary" />
      <br/>
      <AutoSubIcon style={{ height: 48, width: 80 }} />
      <AutoSubIcon style={{ height: 48, width: 80 }} color="error" />
      <AutoSubIcon style={{ height: 48, width: 80 }} color="primary" />
      <AutoSubIcon style={{ height: 48, width: 80 }} color="secondary" />
    </>
  ))
